import { render, staticRenderFns } from "./TheArrowHorizIcon.vue?vue&type=template&id=84229022&scoped=true&"
import script from "./TheArrowHorizIcon.vue?vue&type=script&lang=js&"
export * from "./TheArrowHorizIcon.vue?vue&type=script&lang=js&"
import style0 from "./TheArrowHorizIcon.vue?vue&type=style&index=0&id=84229022&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84229022",
  null
  
)

export default component.exports